"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const TextSize_1 = require("./types/TextSize");
const TextView_1 = require("./types/TextView");
const TextWeight_1 = require("./types/TextWeight");
exports.StyledText = (0, styled_components_1.default)(react_1.default.forwardRef((_a, ref) => {
    var { asTag, children } = _a, rest = __rest(_a, ["asTag", "children"]);
    return react_1.default.createElement(asTag || 'div', (0, helpers_1.clearProps)(rest, { ref }), children);
})) `
    display: block;
    box-sizing: border-box;
    flex-direction: row;
    align-items: center;
    justify-content: inherit;
    font-family: ${({ theme }) => theme.fonts.family};
    text-align: inherit;
    margin: 0;

    ${({ truncate }) => truncate &&
    (0, styled_components_1.css) `
            max-width: 100%;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}

    ${({ size = TextSize_1.TEXT_SIZE.m, weight = TextWeight_1.TEXT_WEIGHT.normal, theme }) => (0, styled_components_1.css) `
        font-size: ${theme.fonts.sizes[size]};
        line-height: ${theme.fonts.lineHeights[size]};
        font-weight: ${theme.fonts.weights[weight]};
        letter-spacing: ${theme.fonts.letterSpacings[size]};
    `}
    
    ${({ view = TextView_1.TEXT_VIEW.primary, theme }) => (0, styled_components_1.css) `
        color: ${theme.fonts.colors[view]};
    `}
    
    ${({ align }) => (0, styled_components_1.css) `
        text-align: ${align || 'left'};
    `}
    
    ${({ leader, theme }) => leader &&
    (0, styled_components_1.css) `
            margin-top: ${theme.spacing[leader]};
        `}
    
    ${({ trailer, theme }) => trailer &&
    (0, styled_components_1.css) `
            margin-bottom: ${theme.spacing[trailer]};
        `}
    
    ${({ whitespace }) => whitespace &&
    (0, styled_components_1.css) `
            white-space: ${whitespace};
        `}
`;
//# sourceMappingURL=Text.styles.js.map